import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { Dialog, DialogContent, DialogTitle, Switch } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import CustomTableGrid from 'components/uiComponents/CustomTableGrid';
import FormikControl from 'components/wrapperComponents/FormikControl';
import { msgTypes } from 'constants/msgTypes';
import { Form, Formik } from 'formik';
import { MembershipModel } from 'model/screensModels/membership/MembershipModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import React, { useEffect, useMemo, useState } from 'react';
import { BlogSchema } from 'schemas/menu/blog/BlogSchema';
import { MembershipService } from 'services/menu/membership/MembershipService';
import { conformationAlert } from 'services/shared/alert';
import ResetPasswordDialogBox from './ResetPasswordDialogBox';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Button from '@mui/material/Button';

const RegisteredMembersList = ({ setFlag, updateRecord }) => {
  const [registeredMembersList, setRegisteredMembersList] =  useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [open, setOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(new MembershipModel());

  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  })

  const columns = useMemo(
    () => [
      {
        accessorKey: "companyName",
        header: "Company Name",
        size: 100,
      },
      {
        accessorKey: "companyEmail",
        header: "Company Email",
        size: 100,
      },
      {
        accessorKey: "membershipType",
        header: "Membership Type",
        size: 50,
      },
      {
        accessorKey: "expiryDate",
        header: "Expired On",
        size: 50,
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 50,
        Cell: ({ cell, row }) => (
          <Switch
            name="status"
            checked={row?.original?.status === "Blocked" ? false : true}
            onChange={() => {
              updateStatus(row.original)
            }}
          />
        ),
      },
      {
        header: "Action",
        size: 50,
        Cell: ({ cell, row }) => (
          <div className='d-flex'>
            {(row.original.status === 'Active') && (
              <>
                <Tooltip title="Edit">
                  <EditIcon fontSize="small" onClick={() => { editRecord(row.original) }} />
                </Tooltip>
                    <Tooltip title="Delete">
                              <DeleteIcon fontSize="small" onClick={() => { deleteRecord(row.original) }} />
                            </Tooltip>
                <Tooltip title="Reset Password">
                  <VpnKeyIcon fontSize="small" onClick={() => { resetPassword(row.original) }} />
                </Tooltip>
              </>
            )}

          </div>
        ),
      },
    ],
    []
  );
  const deleteRecord = async (record: MembershipModel) => {
    const requestData: MembershipModel = new MembershipModel();
    requestData.companyId = record.companyId

    const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");

    if (deleteFlag) {
      const res = await MembershipService.deleteMembership(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getregisteredMembersList();
     
      }
    }
  }
  // //Begin:: UseEffect Hooks 

  useEffect(() => {
    getregisteredMembersList();
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])

  //End:: UseEffect Hooks 


  const resetPassword = (rowData) => {
    setOpen(true);
    setSelectedRow(rowData)
  };


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



  const updateStatus = async (record: MembershipModel) => {
    const requestData: MembershipModel = new MembershipModel();
    requestData.companyId = record.companyId;
    requestData.companyEmail = record.companyEmail;


    const updateStatusFlag = await conformationAlert(
      msgTypes.CONFORMATION_MESSAGE.UPDATE_RECORD,
      msgTypes.CONFORMATION_ICON.WARNING,
      "Yes! Update"
    );
    if (updateStatusFlag) {
      const res = await MembershipService.updateMembershipStatus(
        requestData
      );
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getregisteredMembersList();
      }
    }
  };


  //Prepare request body to get blog list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  }


  const getregisteredMembersList = async () => {
    const requestBody = prepareRequest();
    const res = await MembershipService.getregisteredMembersList(
      requestBody
    );
    let filterData = undefined;
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setRegisteredMembersList(res);
        filterData = res.data.tbody.map((data: MembershipModel) => {
          return {
            "Company Name": data.companyName,
            "Company Email": data.companyEmail,
            "Membership Type": data.membershipType,
            "Phone Number": data.primaryPhoneNumber,
            "Expired On": data.expiryDate,
            "Company Status": data.status,
            "Country Name": data.countryName,
            "City": data.stateName,
            "Address 1": data.addressLine1,
          }
        })
        setExportAsExcel({ fileName: "RegisteredMemberList.xlsx", data: filterData })
      } else {
        setRegisteredMembersList(new ResponseModel());
        setExportAsExcel({ fileName: "RegisteredMemberList.xlsx", data: [] })
      }
    }
  };




  //Open Form To edit Record
  const editRecord = (record) => {
    updateRecord(record);
    setFlag(true)
  }

  const initialValues = {}
  const onSubmit = () => {
    getregisteredMembersList();
  }

  

  const [exportAsExcel, setExportAsExcel] = useState({
    data: [],
    fileName: "RegisteredMembers.xlsx"
  });
  


  const downloadExcel = () => {
    if (!exportAsExcel || !Array.isArray(exportAsExcel.data) || exportAsExcel.data.length === 0) {
      console.warn("No data to export");
      return;
    }
  
    const worksheet = XLSX.utils.json_to_sheet(exportAsExcel.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
  
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, exportAsExcel.fileName || "RegisteredMembers.xlsx");
  };
  




  return (
    <>
    {exportAsExcel?.data?.length > 0 && (
  <div style={{ textAlign: "right", marginTop: "16px" }}>
    <button type="button" className="btn btn-primary download-register" onClick={downloadExcel}>
      Download
    </button>
  </div>
)}

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={BlogSchema}
        onSubmit={onSubmit}
      >
        {
          formik =>
          (
            <Form>
                 {registeredMembersList ? (
              <CustomTableGrid
                item={
                  <FormikControl
                    control='materialTable'
                    tableColumn={columns}
                    tableData={registeredMembersList}
                    setPagination={setPagination}
                    exportExcel={exportAsExcel}
                  />
                }
              />
            ) : null}
            </Form>

          )
        }
      </Formik>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const email = formJson.email;
            handleClose();
          },
        }}
      >
        <DialogTitle>Subscribe</DialogTitle>
        <DialogContent>
          < ResetPasswordDialogBox open={open} setOpen={setOpen} rowData={selectedRow} />
        </DialogContent>
      </Dialog>

    </>
  )
}
export default RegisteredMembersList;
